import { z } from 'zod'

export const FoodStockFoodItemStatus = z.enum([
  'EXPIRED',
  'EXPIRING_SOON',
  'VALID'
])
export type FoodStockFoodItemStatus = z.infer<typeof FoodStockFoodItemStatus>
